import React from 'react';
import Header from "../components/custom/header";
import ViewInvoice from "../components/invoice/view-invoice";
import SessionTimeout from "../components/session-timeout";

const ViewInvoicePage = () => {

    return (
        <React.Fragment>
            {
                <div>
                    <Header />
                    <ViewInvoice/>
                    <SessionTimeout/>
                </div>
            }
        </React.Fragment>
    )
}

export default (ViewInvoicePage);
